import { AppLayout } from "@/components/layout/AppLayout";
import { usePageTitle } from "@/hooks/usePageTitle";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { SonarPage } from "@/features/raio-x/components/SonarPage";
import { PlanejamentoPage } from "@/features/raio-x/components/PlanejamentoPage";
import { MetricasComerciaisPage } from "@/features/raio-x/components/MetricasComerciaisPage";
import { CpaMaximoPage } from "@/features/raio-x/components/CpaMaximoPage";

export default function RaioX() {
  usePageTitle("Raio-X do Funil");

  return (
    <AppLayout>
      <div className="flex flex-col gap-6">
        <div>
          <h1 className="text-2xl font-semibold tracking-[-0.022em] text-foreground">
            Raio-X do Funil
          </h1>
          <p className="text-sm text-muted-foreground mt-1">
            Diagnóstico e planejamento completo do funil de vendas
          </p>
        </div>

        <Tabs defaultValue="sonar" className="w-full">
          <TabsList className="h-9 bg-muted p-0.5 gap-0.5">
            <TabsTrigger
              value="sonar"
              className="h-8 px-3 text-xs font-medium data-[state=active]:bg-card data-[state=active]:text-foreground data-[state=active]:shadow-sm"
            >
              Sonar
            </TabsTrigger>
            <TabsTrigger
              value="planejamento"
              className="h-8 px-3 text-xs font-medium data-[state=active]:bg-card data-[state=active]:text-foreground data-[state=active]:shadow-sm"
            >
              Planejamento
            </TabsTrigger>
            <TabsTrigger
              value="metricas"
              className="h-8 px-3 text-xs font-medium data-[state=active]:bg-card data-[state=active]:text-foreground data-[state=active]:shadow-sm"
            >
              Métricas
            </TabsTrigger>
            <TabsTrigger
              value="cpa"
              className="h-8 px-3 text-xs font-medium data-[state=active]:bg-card data-[state=active]:text-foreground data-[state=active]:shadow-sm"
            >
              CPA Máximo
            </TabsTrigger>
          </TabsList>

          <TabsContent value="sonar" className="mt-6">
            <SonarPage />
          </TabsContent>
          <TabsContent value="planejamento" className="mt-6">
            <PlanejamentoPage />
          </TabsContent>
          <TabsContent value="metricas" className="mt-6">
            <MetricasComerciaisPage />
          </TabsContent>
          <TabsContent value="cpa" className="mt-6">
            <CpaMaximoPage />
          </TabsContent>
        </Tabs>
      </div>
    </AppLayout>
  );
}
